import { HasChildren } from "@/types/shared";
import { motion } from "framer-motion";
import tw from "twin.macro";
import { fadeRouteProps } from "./AnimatedRoute.motion";

/** Vert Bienesis (issu du logo `public/logo.svg`). */
const BIENESIS_GREEN = "#146d42";

const Layout = ({ children }: HasChildren) => {
  return (
    <motion.main
      {...fadeRouteProps}
      css={[
        // `h-dvh` (dynamic viewport height) au lieu de `h-screen` (= 100vh) :
        // sur iOS Chrome, `100vh` inclut la zone occupée par la barre d'URL,
        // ce qui décale la BottomNavigation et compresse l'espace en bas du
        // contenu. `100dvh` s'ajuste à la viewport réellement visible quel
        // que soit le navigateur (Safari, Chrome, Firefox iOS…).
        tw`h-dvh w-full overflow-x-hidden isolate flex flex-col`,
        { backgroundColor: BIENESIS_GREEN },
      ]}
    >
      {/* Bandeau Bienesis — bloc vert avec dégradé léger, logo + wordmark,
          terminé par une vague "n n" qui adoucit la jonction avec le contenu. */}
      <header tw="shrink-0 relative">
        <div
          css={[
            tw`flex flex-col items-center justify-center gap-2 px-4`,
            tw`pt-[calc(env(safe-area-inset-top)+1.25rem)] pb-0`,
            {
              backgroundColor: BIENESIS_GREEN,
            },
          ]}
        >
          <img src="/logo.svg" alt="Bienesis" tw="h-11 w-auto" />
          <span tw="text-white font-semibold tracking-[0.4em] text-sm">
            BIENESIS
          </span>
        </div>

        {/* Vague "n n" — un creux à gauche, une bosse à droite. preserveAspectRatio="none"
            étire la forme à n'importe quelle largeur. La hauteur réelle (h-16) donne
            assez de place pour que la courbe soit franche. */}
        <svg
          viewBox="0 0 1440 48"
          preserveAspectRatio="none"
          aria-hidden="true"
          tw="block w-full h-16 -mt-px"
        >
          {/* Fond crème — la zone sous la courbe doit "appartenir" à la zone
              de contenu, pas au bandeau vert. */}
          <rect x="0" y="0" width="1440" height="48" fill="#FBF8F4" />
          <path
            d="M 0 0 L 1440 0 L 1440 30 C 1260 5 900 5 720 30 C 540 55 180 55 0 30 Z"
            fill={BIENESIS_GREEN}
          />
        </svg>
      </header>

      <div
        css={[
          tw`flex-1 min-h-0 w-full overflow-x-hidden overflow-y-auto bg-[#FBF8F4]`,
          tw`pb-24`,
        ]}
      >
        {children}
      </div>
    </motion.main>
  );
};

export default Layout;
